// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { createSupport, uploadFile } from '../../../apis/base';
import { RootAction, actionCreatorsList } from '../../rootActionCreator';
const { createNewSupportActions } = actionCreatorsList;

const outputActions = {
  success: createNewSupportActions.success,
  failure: createNewSupportActions.failure
};

type RequestActionTypes = ActionType<
  typeof createNewSupportActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

const createNewSupportEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(createNewSupportActions.request)
    ),
    switchMap(async (action: RequestActionTypes) => {
      const { message, imagesFiles, title, supportType } = action.payload;
      const imagesUrls = [];
      if (imagesFiles?.length) {
        for (const imageFile of imagesFiles) {
          const { fileName, upload } = await uploadFile(imageFile);
          await upload;
          imagesUrls.push(fileName)
        }
      }

      return createSupport(
        message,
        imagesUrls,
        title,
        supportType
      ).then((data) => {
        return outputActions.success({data: data.data});
      }).catch((error: AxiosError) => {
        console.log(error)
        return outputActions.failure({ error });
      });
    })
  );
};

export { createNewSupportEpic as default};
